import React from 'react'
import i18n from 'live/services/i18n'
import styled from 'styled-components'

const OptionLabel = styled.div`
    i {
        margin-right: 8px;
    }
`

export const recurrenceOptions = [
    {
        value: 'ONE_TIME',
        label: (
            <OptionLabel>
                <i className="fa fa-circle" />
                <span>{i18n('One-Time')}</span>
            </OptionLabel>
        ),
        description: ''
    },
    {
        value: 'RECURRENT',
        label: (
            <OptionLabel>
                <i className="fa fa-repeat" />
                <span>{i18n('Recurrent')}</span>
            </OptionLabel>
        ),
        description: ''
    }
]

export const actionOptions = [
    {
        value: 'DELETE',
        label: (
            <OptionLabel>
                <i className="fa fa-eraser" />
                <span>{i18n('Delete')}</span>
            </OptionLabel>
        ),
        description: ''
    },
    {
        value: 'KEEP',
        label: (
            <OptionLabel>
                <i className="fa fa-lock" />
                <span>{i18n('Keep')}</span>
            </OptionLabel>
        ),
        description: ''
    }
]
